import { useGetRisksRiskDirectoryIdNodesSuspense } from "api/generated/risks/risks";

type ISOTimestamp = string;
type RiskEntityId = string;
export function useRiskNodesQuery(
    id: string,
    at?: ISOTimestamp,
    focus?: RiskEntityId
) {
    return useGetRisksRiskDirectoryIdNodesSuspense(
        Number(id),
        { at: at || undefined, entity_id: focus ? Number(focus) : undefined },
        {
            query: {
                select: (response) => response.data,
            },
        }
    );
}
